import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route, Navigate,
} from 'react-router-dom';
import './App.css';
import './assets/fonts/fonts.css';
import Home from './components/pages/home/home';
import About from './components/pages/about/about';
import Reference from './components/pages/reference/reference';
import Contact from './components/pages/contact/contact';
import StatusCheck from './components/pages/statusCheck/statusCheck';
import Demo from './components/pages/demo/demo';
import SC from './components/pages/products/sc/sc';
import CC from './components/pages/products/cc/cc';
import PP from './components/pages/products/pp/pp';

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" Component={Home} />
        <Route path="/statuscheck" Component={StatusCheck} />
        <Route path="/products/sc" Component={SC} />
        <Route path="/products/cc" Component={CC} />
        <Route path="/products/pp" Component={PP} />
        <Route path="/reference" Component={Reference} />
        <Route path="/about" Component={About} />
        <Route path="/demo" Component={Demo} />
        <Route path="/contact" Component={Contact} />
        <Route
          path="*"
          element={(
            <Navigate
              replace
              to="/"
            />
              )}
        />
      </Routes>
    </Router>
  );
}

export default App;
